import { useState } from 'react';
import useFetch from '../../../../hooks/useFetch';
import { ServiceEvents } from '../../shared/interfaces';
import { buildEndpointIntranetCompany } from '../../EndPoints';
import { Event, EventFilters } from '../../../models/Event';

const useEventService = () => {
    const { doGet, doPost, doPut, doDelete } = useFetch();

    const [fetchingGetEvents, setFetchingGetEvents] = useState(false);
    const [fetchingShowEvent, setFetchingShowEvent] = useState(false);
    const [fetchingStoreEvent, setFetchingStoreEvent] = useState(false);
    const [fetchingEditEvent, setFetchingEditEvent] = useState(false);
    const [fetchingUpdateEvent, setFetchingUpdateEvent] = useState(false);
    const [fetchingDeleteEvent, setFetchingDeleteEvent] = useState(false);
    const [fetchingActiveEvent, setFetchingActiveEvent] = useState(false);

    const getEvents = (bankFilters: EventFilters, events: ServiceEvents = {}) => {
        const queryString = Object.entries(bankFilters)
            .map(([key, value]) => `${key}=${value}`)
            .join('&');

        doGet({
            ...events,
            type: 'company',
            url: `${buildEndpointIntranetCompany('events/events')}?${queryString}`,
            setFetching: setFetchingGetEvents
        });
    };

    const showEvent = (id: number, events: ServiceEvents = {}) => {
        doGet({
            ...events,
            type: 'company',
            url: `${buildEndpointIntranetCompany(`events/events/${id.toString()}/show`)}`,
            setFetching: setFetchingShowEvent
        });
    };

    const storeEvent = (bank: Event, events: ServiceEvents = {}) => {
        doPost({
            ...events,
            url: `${buildEndpointIntranetCompany(`events/events/store`)}`,
            type: 'company',
            body: bank,
            setFetching: setFetchingStoreEvent
        });
    };

    const editEvent = (id: number, events: ServiceEvents = {}) => {
        doGet({
            ...events,
            type: 'company',
            url: `${buildEndpointIntranetCompany(`events/events/${id.toString()}/edit`)}`,
            setFetching: setFetchingEditEvent
        });
    };

    const updateEvent = (id: number, event: Event, events: ServiceEvents = {}) => {
        doPut({
            ...events,
            type: 'company',
            url: `${buildEndpointIntranetCompany(`events/events/${id.toString()}/update`)}`,
            body: event,
            setFetching: setFetchingUpdateEvent
        });
    };

    const deleteEvent = (id: number, events: ServiceEvents = {}) => {
        doDelete({
            ...events,
            type: 'company',
            url: `${buildEndpointIntranetCompany(`events/events/${id.toString()}/delete`)}`,
            setFetching: setFetchingDeleteEvent
        });
    };

    const activeEvent = (id: number, active: boolean, events: ServiceEvents = {}) => {
        doPost({
            ...events,
            type: 'company',
            url: `${buildEndpointIntranetCompany(`events/events/${id.toString()}/active`)}`,
            body: { active: active },
            setFetching: setFetchingActiveEvent
        });
    };

    return {
        fetchingGetEvents,
        fetchingShowEvent,
        fetchingStoreEvent,
        fetchingEditEvent,
        fetchingUpdateEvent,
        fetchingDeleteEvent,
        fetchingActiveEvent,
        getEvents,
        showEvent,
        storeEvent,
        editEvent,
        updateEvent,
        deleteEvent,
        activeEvent
    };
};

export default useEventService;
